module.exports = __webpack_public_path__ + "img/m4.7f19a6eb.png";